<ng-template cellTemplate let-dataItem="dataItem">
    <span (click)="$event['ignoreClickOutside'] = true">{{dataItem | property: labelField}}</span>
</ng-template>
<ng-template editTemplate let-dataItem="dataItem" let-columnIndex="columnIndex" let-column="column"
             let-formGroup="formGroup">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editControl"></wbo-edit-grid-cell-activator>
    <wbo-measure-single-select-edit-control #editControl (focussed)="columnFocusHandler($event, columnIndex)"
                                            [formControl]="formGroup.get(valueField)"
                                            [inventoryMeasureIdentifier]="inventoryMeasureIdentifier"
                                            [showConvertibleMeasures]="convertToRequired"
                                            [base]="false"
                                            [extendedSearchComponentParams]="extendedSearchComponentParams"
                                            [extendedEditComponentParams]="extendedEditComponentParams"
                                            [objectValue]="formGroup.get(field)">
    </wbo-measure-single-select-edit-control>
</ng-template>
